import { Trans } from '@lingui/react/macro';

import { Link } from '@/components/Link/Link';
import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import { ShipmentWithRelations } from '@/models/shipment';

export const ShipmentBreadcrumb = ({ shipment }: { shipment: ShipmentWithRelations }) => {
  return (
    <Stack row gap="0.5rem" alignItems="center">
      <InlineText color="disabled">
        <Link to={`/shipments`} className="reset-link">
          <Trans id="request.breadcrumb.shipments">Shipments</Trans>
        </Link>
      </InlineText>

      <InlineText color="disabled">&gt;</InlineText>
      <InlineText>{shipment.reference}</InlineText>
    </Stack>
  );
};
